module.exports = __webpack_public_path__ + "img/H4.eacdd11a.png";